'use client';
class JSONParseError extends Error {
    constructor(rawString, response, request, options){
        super(`Не удалось десериализовать тело ответа: "${rawString}"`);
        this.name = 'JSONParseError';
        this.rawString = rawString;
        this.response = response;
        this.request = request;
        this.options = options;
        Object.setPrototypeOf(this, JSONParseError.prototype);
    }
}

export { JSONParseError };
//# sourceMappingURL=JSONParseError.js.map
